import React, { useMemo, useState } from "react";

export const useFileInput = () => {
    const [files, setFiles] = useState<File[]>([]);

    const handleAddFile = (e: React.MouseEvent, file: File) => {
        e.stopPropagation();
        setFiles(prevFiles => [...prevFiles, file]);
    };

    const handleRemoveFile = (e: React.MouseEvent, file: File) => {
        e.stopPropagation();
        setFiles(prevFiles => prevFiles.filter(f => f.name !== file.name));
    };

    const handleNativeChange = (e: Event, callback?: (files: File[]) => void) => {
        const target = e.target as HTMLInputElement;
        const selectedFiles = target.files;
        if (selectedFiles) {
            const fileArray = Array.from(selectedFiles);
            setFiles(fileArray);
            if (callback) callback(fileArray);
        }
    };

    const onChange = (e: React.ChangeEvent<HTMLInputElement>, callback?: (files: File[]) => void) => {
        const selectedFiles = e.target.files;
        if (selectedFiles) {
            const fileArray = Array.from(selectedFiles);
            setFiles(fileArray);
            if (callback) callback(fileArray);
        }
    };

    const handleIconClick = (
        fileInputAttributes: Partial<HTMLInputElement>,
        callback?: (files: File[]) => void
    ) => (e: React.MouseEvent) => {
        e.stopPropagation();
        const fileInput = document.createElement("input");
        fileInput.type = "file";

        Object.entries(fileInputAttributes).forEach(([key, value]) => {
            if (value !== undefined && value !== null) {
                fileInput.setAttribute(key, String(value));
            }
        });

        fileInput.onchange = (ev: Event) => {
            handleNativeChange(ev, callback);
        };

        fileInput.click();
    };

    const hasFiles = useMemo(() => files.length > 0, [files]);

    return { handleAddFile, onChange, handleRemoveFile, handleIconClick, files, setFiles, hasFiles };
};